<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;" shadow="never">
      <el-form label-position="left"
               label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">外出信息</el-divider>
        <el-form-item v-show="false" label="申请时间" prop="applyTime">
        </el-form-item>

        <el-form-item label="外出类型" prop="hasProject">
          <el-radio-group v-model="detail.hasProject" >
            <el-radio label="1">项目外出</el-radio>
            <el-radio label="2">其他外出</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="detail.hasProject==1" label="外出项目" prop="projectId">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>
        <el-form-item label="外出人员" prop="userIdStr">
          <el-input v-model="outUserNames" readonly></el-input>
        </el-form-item>
        <el-form-item label="外出时间" prop="outTimes">
          <el-date-picker
              readonly
              v-model="detail.outTimes"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="外出形式" prop="publicTransport" readonly>
          <el-radio-group v-model="detail.publicTransport">
            <el-radio label="1">公共交通</el-radio>
            <el-radio label="2">自驾</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="detail.driverUserId != null" label="替驾人员" prop="driverUserName">
          <el-input v-model="driverUserName" readonly></el-input>
        </el-form-item>
        <el-form-item label="外出地点" prop="outAddress">
          <el-input v-model="detail.outAddress" readonly></el-input>
        </el-form-item>
        <el-form-item label="外出事由" prop="outSubject">
          <el-input type="textarea" rows=5 maxlength="500" show-word-limit
                    v-model="detail.outSubject" readonly></el-input>
        </el-form-item>

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>


        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import {AesDecrypt} from "@/util";

export default {
  components: {AuditList, Title, Setp},
  name: "OutReportDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '外出申请详情',
        path: ''
      },
      detail: {
        outTimes: []
      },
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      outUserNames: "",
      driverUserName: "",
      user: {},
      nodes: [],
      allowAudit: false,
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    const user = JSON.parse(AesDecrypt(window.localStorage.getItem("user")))
    this.userId = user.userId
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.detail.hasProject = String(this.detail.hasProject)
            this.detail.publicTransport = String(this.detail.publicTransport)
            if (res.object.detail.outBegainTime && res.object.detail.outEndTime) {
              this.$set(this.detail, "outTimes", [
                "" + res.object.detail.outBegainTime + "",
                "" + res.object.detail.outEndTime + "",
              ]);
            }
            this.outUserNames = Array.isArray(res.object.outUserNames)
                ? res.object.outUserNames.join(',')
                : (res.object.outUserNames || '')
            this.driverUserName = String(res.object.driverUserName)
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
            if (this.userId !== this.user.userId) {
              this.buttonArray = []
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style>


</style>
